/* eslint-disable react/no-deprecated */

import React from "react"
import classnames from "classnames"
import styles from "./MyMazdaDetails.less"
import gtmHandler from "AtomicUtils/gtmHandler"
import { InputText, Button, H3, Content, FormGroup, Space } from "AtomicComponents"
import InputSearchable from "../InputSearchable/InputSearchable"
import { HeroContent, AlertList } from "AtomicContainers"
import fetchAPI from "AtomicUtils/fetchAPI"
import { fromLinkInputs, formLinkSubmit } from "AtomicUtils/formHandler"
import MESSAGES from "AtomicConstants/MESSAGES"
import urlHandler from "AtomicUtils/urlHandler"
import { WINDOW } from "constants/environment"

class MyMazdaDetails extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      form: {
        firstName: {
          validations: {
            required: MESSAGES.FIRSTNAME_REQUIRED
          }
        },
        lastName: {
          validations: {
            required: MESSAGES.LASTNAME_REQUIRED
          }
        },
        phone: {
          validations: {
            required: MESSAGES.PHONE_NUMBER_REQUIRED,
            phone: MESSAGES.PHONE_NUMBER_INVALID
          }
        },
        address: {
          validations: {
            required: MESSAGES.ADDRESS_REQUIRED,
            address: MESSAGES.ADDRESS_INVALID
          }
        },
        vinRego: {
          validations: {
            required: MESSAGES.REGO_OR_VIN_REQUIRED
          }
        },
        submitButton: { disabled: true }
      },
      success: false,
      errorMessage: null
    }
  }

  componentDidMount() {
    const currentURL = new urlHandler(WINDOW.location.href)

    // if queryParams doesnt have email redirect it back
    const { unsuccessfulRedirectUrl = "/" } = this.props
    if (!currentURL.query.email) {
      new urlHandler(unsuccessfulRedirectUrl)
        .redirect()
    }

    this.setState({
      form: {
        ...this.state.form,
        email: {
          value: currentURL.query.email
        }
      }
    })
  }

  _handleSubmit = async (event) => {
    if (event) event.preventDefault()
    const { loading, form } = this.state
    if (!loading && !form.submitButton.disabled) {
      await this.setState({
        loading: true
      }, async () => {
        const { createAccountApiEndpoint } = this.props
        const { form } = this.state
        await fetchAPI({
          method: "POST",
          url: createAccountApiEndpoint,
          body: {
            email: form.email.value,
            firstName: form.firstName.value,
            lastName: form.lastName.value,
            phone: form.phone.value,
            address: form.address.value.description,
            vinOrRegistration: form.vinRego.value
          }
        })
          .then(async (response) => {
            const json = await response.json()
            const { success, errorMsg } = json
            if (!success) {
              this.setState({
                errorMessage: errorMsg,
                loading: false
              })
            } else {
              // successful
              this.setState({
                loading: false,
                success: true
              }, () => {
                gtmHandler({
                  pageCategory: "MyMazda Details Form",
                  pageAction: "MyMazda Details Form - Submit"
                })
              })
            }
          })
          .catch((response) => {
            this.setState({
              errorMessage: response.message || `Failed with status ${response.status}`,
              loading: false
            })
          })
      })
    }
  }

  render() {
    const { buttonText = "Submit", heading, blurb, submitInstructionsText, createAccountApiEndpoint, registrationSuccessfulText, successfulRedirectUrl } = this.props
    const { loading, success, errorMessage } = this.state

    if (success) {
      return (
        <div className={classnames({ [styles.MyMazdaDetails]: true  })}>
          <div className={classnames({ [styles.MyMazdaDetailsForm]: true })}>
            <FormGroup>
              <HeroContent
                heading={"Thank you"}
                description={registrationSuccessfulText || "We're setting up your account. We'll be in touch when it's ready for you to use."} />
            </FormGroup>
            <FormGroup>
              <Button styleName="black" href={successfulRedirectUrl} fullWidth={true}>
                MyMazda home
              </Button>
            </FormGroup>
          </div>
        </div>
      )
    }

    return (
      <div className={classnames({ [styles.MyMazdaDetails]: true })}>
        <div className={classnames({ [styles.MyMazdaDetailsForm]: true })}>
          <form method="POST" onSubmit={this._handleSubmit}>
            <FormGroup>
              <H3>{heading || "MyMazda Registration"}</H3>
              <Content xmlString={blurb || "Please share your details below to complete the process."} />
            </FormGroup>
            <FormGroup>
              <InputText
                name="firstName"
                label="First Name"
                {...fromLinkInputs(this, "firstName")}
                onBlur={() => {
                  gtmHandler({
                    pageCategory: "Get In Touch Form",
                    pageAction: "Get In Touch Form - Entered \"FIRSTNAME\""
                  })
                }}
              />
            </FormGroup>
            <FormGroup>
              <InputText
                name="lastName"
                label="Last Name"
                {...fromLinkInputs(this, "lastName")}
                onBlur={() => {
                  gtmHandler({
                    pageCategory: "Get In Touch Form",
                    pageAction: "Get In Touch Form - Entered \"LASTNAME\""
                  })
                }}
              />
            </FormGroup>
            <FormGroup>
              <InputText
                name="phone"
                label="Phone"
                {...fromLinkInputs(this, "phone")}
                onBlur={() => {
                  gtmHandler({
                    pageCategory: "Get In Touch Form",
                    pageAction: "Get In Touch Form - Entered \"PHONE\""
                  })
                }}
              />
            </FormGroup>
            <FormGroup>
              <InputSearchable
                name="address"
                type="address"
                label="Address"
                {...fromLinkInputs(this, "address")}
                onBlur={() => {
                  gtmHandler({
                    pageCategory: "Get In Touch Form",
                    pageAction: "Get In Touch Form - Selected address"
                  })
                }}
              />
            </FormGroup>
            <FormGroup>
              <InputText
                name="vinRego"
                label="Registration or VIN"
                {...fromLinkInputs(this, "vinRego")}
                onBlur={() => {
                  gtmHandler({
                    pageCategory: "Get In Touch Form",
                    pageAction: "Get In Touch Form - Entered \"REGISTRATION OR VIN\""
                  })
                }}
              />
            </FormGroup>
            <FormGroup center>
              <Content xmlString={submitInstructionsText} />
            </FormGroup>
            <FormGroup>
              <AlertList data={errorMessage} />
              <Button styleName="black" loading={loading} fullWidth {...formLinkSubmit(this, this._handleSubmit)}>
                {buttonText}
              </Button>
            </FormGroup>
          </form>
        </div>
      </div>
    )
  }
}

export default MyMazdaDetails



// WEBPACK FOOTER //
// ./src/AtomicContainers/MyMazdaDetails/MyMazdaDetails.jsx